import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { CaseLogType } from '../../cases/_types/case-log-type';
import { CaseLogTypesService } from '../../cases/_services/cases-log-types.service';

@Component({
    selector: 'app-cases-log-types-detail',
    templateUrl: './cases-log-types-detail.component.html',
    styleUrls: ['./cases-log-types-detail.component.scss'],
    standalone: false
})
export class CasesLogTypesDetailComponent {
  public caseStateFormGroup!: RxFormGroup;

  public caseState: CaseLogType = new CaseLogType();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  //el JSON de campos solo lo edita quien tiene el permiso específico (por defecto, solo ADMINISTRADOR)
  public allowFieldsConfiguration: boolean = false;

  constructor(
    private casesLogTypesService: CaseLogTypesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
  ) {

    this.caseStateFormGroup = this.formBuilder.formGroup<CaseLogType>(this.caseState) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle de categoría de eventos");
    this.topbarService.addBreadcrumb("Categorías de eventos", "/casesLogTypes");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadCaseLogTypes(id);
    }
    this.allowWrite = this.loginService.hasPermission("CASES_LOGS_TYPES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES_LOGS_TYPES.DELETE");
    this.allowFieldsConfiguration = this.loginService.hasPermission("CASES_LOGS_TYPES.FIELDS_CONFIGURATION");

  }

  async loadCaseLogTypes(id: string) {
    this.caseState = await firstValueFrom(this.casesLogTypesService.get(id));
    this.caseStateFormGroup.patchValue(this.caseState);
  }


  /**
   * La configuración de campos se edita como JSON en texto: comprobamos que parsee antes de guardar,
   * porque un JSON inválido dejaría la categoría sin formulario sin avisar a nadie.
   */
  private isFieldsConfigurationValid(): boolean {
    if (!this.allowFieldsConfiguration) return true;
    let configuration = this.caseStateFormGroup.value.fieldsConfiguration;
    if (configuration == null || configuration.trim() == '') return true;
    try {
      let parsed = JSON.parse(configuration);
      if (!Array.isArray(parsed?.fields)) {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "El JSON de campos debe tener una propiedad 'fields' con una lista." });
        return false;
      }
      return true;
    } catch (error) {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "El JSON de campos no es válido." });
      return false;
    }
  }

  async save() {
    if (!this.isFieldsConfigurationValid()) return;
    let valid = this.formValidationService.validateForm(this.caseStateFormGroup);
    if (valid) {
      this.caseState = Object.assign(this.caseState, this.caseStateFormGroup.value);
      let caseState = await firstValueFrom(this.casesLogTypesService.save(this.caseState));
      this.messageService.add({ closable: true, severity: 'success', summary: "Estado de expediente guardado correctamente." });
      this.router.navigate(['casesLogTypes']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la categoría?",
      header: "Eliminar categoría",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesLogTypesService.delete(this.caseState.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Categoría eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['casesLogTypes']);
  }
}
